<ion-app>
  <ion-router-outlet></ion-router-outlet>

  @if(!isAppReady()) {
  <div class="logo-wrap">
    <ion-img src="logo-green.svg"></ion-img>
  </div>

  }
</ion-app>
